<svelte:options accessors/>
<script>
    import NauiCheckbox from "../../../naui/atoms/NauiCheckbox.svelte";
    import NauiSelect from "../../../naui/atoms/NauiSelect.svelte";

    export let data;

    let espacio_choices = [
        {
            label: 'Oficina',
            value: 'office'
        },
        {
            label: 'Local',
            value: 'local'
        },
        {
            label: 'Movimiento de mercancia / inventario',
            value: 'inventario'
        }
    ];
    let puestos = [
        {
            label: '1 - 10 puestos',
            value: '1'
        },
        {
            label: '11 - 20 puestos',
            value: '2'
        },
        {
            label: '20+ puestos',
            value: '3'
        },
    ];
    let habitaciones = [
        {
            label: '1',
            value: '1 Habitación'
        },
        {
            label: '2',
            value: '2 habitaciones'
        },
        {
            label: '3',
            value: '3 habitaciones'
        },
        {
            label: '4',
            value: '4+ habitaciones'
        },
    ];
</script>
<div>
    <fieldset>
        <legend>TAMAÑO DEL SERVICIO - {data.es_empresa ? 'EMPRESA' : 'CLIENTE'}</legend>
        <div class="grid-2 gap-15 mb-15">
            {#if data.es_empresa}
                <NauiSelect label="Tipo de espacio"
                            bind:value={data.tipo_espacio}
                            options={espacio_choices}/>
                <NauiSelect label="Puestos de trabajo"
                            bind:value={data.puestos}
                            options={puestos}/>
            {:else}
                <NauiSelect label="Cantidad de habitaciones"
                            bind:value={data.cantidad_habitaciones}
                            options={habitaciones}/>
            {/if}
        </div>
        <div class="grid-4 gap-15">
            {#if data.es_empresa}
                <NauiCheckbox label="Archivo"
                              bind:value={data.archivo}/>
                <NauiCheckbox label="Entretenimiento"
                              bind:value={data.entretenimiento}/>
                <NauiCheckbox label="Cocina"
                              bind:value={data.cocina}/>
                <NauiCheckbox label="Sala de reuniones"
                              bind:value={data.sala_reuniones}/>
            {:else}
                <NauiCheckbox label="Depósito"
                              bind:value={data.deposito}/>
                <NauiCheckbox label="Comedor"
                              bind:value={data.comedor}/>
                <NauiCheckbox label="Cocina"
                              bind:value={data.cocina}/>
                <NauiCheckbox label="Zona de ropas"
                              bind:value={data.zona_ropas}/>
                <NauiCheckbox label="Sala"
                              bind:value={data.sala}/>
            {/if}
        </div>
    </fieldset>
</div>